import classNames from 'classnames';
import styles from './style.module.scss';

export const Loader = ({ spinning = true, fullScreen = false }) => (
  <div
    className={classNames(styles.loader, {
      [styles.hidden]: !spinning,
      [styles.fullScreen]: fullScreen,
    })}
  />
);
